import React, { type ComponentProps } from 'react';
import { Tabs } from 'expo-router';

import { useResponsive } from '@garnish/core';

import { NavbarSM, NavbarXS } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarV2 = (props: Props) => {
  const { tabBarProps } = props;

  const { minWidth } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  if (minWidth.isSM) {
    return <NavbarSM />;
  }

  if (!tabBarProps) {
    return null;
  }

  return <NavbarXS tabBarProps={tabBarProps} />;
};

// ─── Types ──────────────────────────────────────────────────────────────────

type Props = {
  tabBarProps?: TabBarProps;
};

type TabBarProps = Parameters<NonNullable<ComponentProps<typeof Tabs>['tabBar']>>[0];
